<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="subAccountsSelected"
    clearable
    :items="subAccountsItems"
    :loading="subAccountsLoading"
    :search-input.sync="subAccountsSearch"
    item-text="Description"
    item-value="id"
    :label="label ? label : $t('SubAccount.title')"
  ></v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import SubAccounts from "@/api/sub_accounts";

export default {
  name: "SearcherSubAccount",

  props: ["value", "label", "bank_codes"],

  computed: {
    subAccountsItems() {
      return this.subAccounts.map((subAccount) => {
        const Description = i18n.t("SubAccount.description", [
          subAccount.account_number,
          subAccount.account_name,
        ]);
        return Object.assign({}, subAccount, { Description });
      });
    },
  },

  data: () => ({
    subAccounts: [],
    subAccountsLoading: false,
    subAccountsSearch: "",
    subAccountsSelected: null,
  }),

  methods: {
    getSubAccountsFromAPI() {
      this.subAccountsLoading = true;
      var data = { keyword: this.subAccountsSearch };
      if (this.bank_codes) {
        data = Object.assign({}, data, { bank_codes: this.bank_codes });
      }
      SubAccounts.fetchAllForSelect(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.subAccounts = response.data.sub_accounts;
            }
            this.subAccountsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.subAccountsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.subAccountsSelected = this.value;
      },
    },
    subAccountsSelected: {
      handler() {
        this.$emit("input", this.subAccountsSelected);
      },
    },
    subAccountsSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.subAccounts.length > 0) return; //拿到结果后就不再重新获取条目
        this.getSubAccountsFromAPI();
      },
    },
    bank_codes: {
      handler() {
        this.getSubAccountsFromAPI();
      },
    },
  },
};
</script>
